<template>
	<v-container>
		<v-row class="text-center">
			<v-col cols="8" offset="2">
				<v-card elevation="2" variant="outlined" shaped tile>
					<!-- prettier-ignore -->
					<v-card-text style="font-size: 16px">
						Sorry, we're having trouble accessing your account, but we're here to help. Please send a quick note to
						<a href="mailto:help@liveswitch.com" target="_blank">help@liveswitch.com</a> and our team will take great care of
						you right away!
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: "BlockedUser"
	};
</script>
